import {
  REQUEST_HOURLY_WOS_SUMMARY,
  RECEIVED_HOURLY_WOS_SUMMARY,
  FAILED_HOURLY_WOS_SUMMARY
} from '../actions/hourly_wos_summary.ac'

export function hourlyWosSummary(
  state = {
    isFetching: false,
    error: null,
    data: {}
  },
  action
) {
  switch (action.type) {
    case REQUEST_HOURLY_WOS_SUMMARY:
      return Object.assign({}, state, {
        isFetching: true
      })
    case RECEIVED_HOURLY_WOS_SUMMARY:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.pkg.data,
        error: null
      })
    case FAILED_HOURLY_WOS_SUMMARY:
      return Object.assign({}, state, {
        isFetching: false,
        data: {},
        error: action.error
      })
    default:
      return state
  }
}
